import { FC, useState } from 'react';
import Image from 'next/image';
import { Modal } from './Modal';
import { ICollage } from './Collage.props';

export const Collage: FC<ICollage> = ({ collageItems }): JSX.Element => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [activeItem, setActiveItem] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(false);

  const openModal = async (idx: number) => {
    setActiveItem(idx);

    const img = typeof window !== 'undefined' ? new window.Image() : null;

    if (img) {
      img.src = collageItems[idx].image;
      img.onload = () => {
        setImageLoaded(true);
        setIsOpenModal(true);
      };
    }
  };

  const closeModal = () => {
    setIsOpenModal(false);
    setImageLoaded(false);
  };

  return (
    <ul className="collage grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
      {collageItems.map((item, idx) => (
        <div key={item.id} className="block" onClick={() => openModal(idx)}>
          {item.image && (
            <Image
              src={item.image}
              alt={item.altText}
              width={256}
              height={256}
              className="h-auto w-full object-cover"
            />
          )}
        </div>
      ))}

      {imageLoaded && (
        <Modal isOpen={isOpenModal} closeModal={closeModal}>
          <Image
            src={collageItems[activeItem].image}
            alt={collageItems[activeItem].altText}
            width={512}
            height={512}
            className="h-auto w-full object-cover opacity-0 transition-opacity duration-300"
            onLoadingComplete={img => {
              img.classList.remove('opacity-0');
            }}
            priority
          />
        </Modal>
      )}
    </ul>
  );
};
